import {RootState} from "@App/store";

const selectPushService = (state: RootState) => state.pushService;

export const selectPushServiceConnectionId = (state: RootState) => selectPushService(state).connectionId;
